<template>  
    <v-text-field ref="inputfield" v-bind="$attrs" type="number" v-model="degVal" @input="inputEPSG4326Value" >
      <template #append-outer>
        <slot name="append-outer"></slot>
      </template>
    </v-text-field>
</template>
<script lang="ts">        
  import Vue from 'vue'  
  import Component from 'vue-class-component'  
import { Watch } from 'vue-property-decorator'

  @Component({
    name: 'LatLngEPSG4326Field', 
    props:{                          
      value:{
        type:Number,
        default:0
      },
      isLat:{
        type:Boolean,
        default:true,
        required:true
      }
    }
  })
  export default class LatLngEPSG4326Field extends Vue {  
        
    private value!:number    
    private isLat!:boolean   
    private degVal = 0

    mounted(){
      this.initData()
    }

    initData()  {            
      this.degVal = this.value
    }  

    @Watch('value')
    onValueChange(){
      this.initData()      
    }

    updateValue(){
      let newV = (isNaN(this.degVal)?0:this.degVal)
      if(this.isLat){
        if(newV > 90) {
          newV = 90
          this.degVal = 90
        }
        else if(newV < -90) {
          newV = -90
          this.degVal = -90
        }
      }
      else{
        if(newV > 180) {
          newV = 180
          this.degVal = 180
        }
        else if(newV < -180) {
          newV = -180
          this.degVal = -180
        }
      }
      this.$emit('input',newV)
    }

    inputEPSG4326Value(newV:any) {
      this.$nextTick(() => {
        this.updateValue()
      })              
    }

  }
</script>
